import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { DIVISIONS } from "../data";

export const Services = () => {
  return (
    <section id="disciplines" data-testid="services-section" className="bg-[var(--ink)] text-white py-24 md:py-40">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-16 md:mb-24">
          <div>
            <div className="flex items-center gap-4 mb-6">
              <span className="h-px w-12 bg-[var(--turq)]" />
              <span className="font-mono-tech text-xs uppercase tracking-[0.25em] text-white/50">Onze disciplines</span>
            </div>
            <h2 className="font-display text-4xl md:text-6xl font-medium tracking-tight leading-[0.98] max-w-3xl">
              Drie afdelingen,<br />één vakkundig team.
            </h2>
          </div>
          <p className="max-w-sm text-white/60 leading-relaxed">
            Elke discipline heeft z'n eigen specialisten. Samen dekken ze het complete bouwtraject — zodat u maar één aanspreekpunt heeft.
          </p>
        </div>

        <div className="space-y-px bg-white/10 border-y border-white/10">
          {DIVISIONS.map((d, i) => (
            <motion.div
              key={d.id}
              id={d.id}
              data-testid={`division-${d.id}`}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
              className="group relative bg-[var(--ink)] grid md:grid-cols-12 gap-6 md:gap-10 items-center px-2 md:px-8 py-10 md:py-14 hover:bg-white/[0.03] transition-colors duration-500"
            >
              <div className="md:col-span-1">
                <span className="font-mono-tech text-sm" style={{ color: d.color }}>{d.index}</span>
              </div>

              <div className="md:col-span-5">
                <span className="font-mono-tech text-[10px] uppercase tracking-[0.2em] text-white/40">{d.tag}</span>
                <h3 className="font-display text-2xl md:text-4xl font-medium tracking-tight mt-3 leading-tight">
                  {d.title}
                </h3>
                <p className="text-white/60 leading-relaxed mt-4 max-w-md">{d.body}</p>
                <div className="flex flex-wrap gap-x-6 gap-y-2 mt-6">
                  {d.points.map((p) => (
                    <span key={p} className="flex items-center gap-2 text-sm text-white/80">
                      <span className="h-1.5 w-1.5 rounded-full" style={{ background: d.color }} /> {p}
                    </span>
                  ))}
                </div>
              </div>

              <div className="md:col-span-5 md:col-start-8">
                <div className="relative overflow-hidden aspect-[16/10] border border-white/10">
                  <img
                    src={d.image}
                    alt={d.title}
                    className="w-full h-full object-cover grayscale group-hover:grayscale-0 scale-100 group-hover:scale-105 transition-[filter,transform] duration-700 ease-out"
                  />
                  <div
                    className="absolute inset-0 opacity-40 group-hover:opacity-0 transition-opacity duration-700"
                    style={{ background: d.color, mixBlendMode: "multiply" }}
                  />
                  <div className="absolute top-4 right-4 h-11 w-11 flex items-center justify-center bg-white text-black translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-[transform,opacity] duration-500">
                    <ArrowUpRight size={20} />
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
